import fuzzysearch from 'fuzzysearch'
export const fuzzyMatch = ({ str = '', pattern = '' }) =>
  fuzzysearch(
    pattern.toString().toLowerCase(),
    str.toLowerCase()
  )
